import React from 'react';
import type { CMSProps, GQLProps } from 'Cms/tour-introduction/resolver';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import { TourInformation } from 'Components/widgets/tour-information/TourInformation';
type TourIntroductionLineProps = CMSProps & GQLProps;
export const TourIntroductionLine = ({
  highlightTitle,
  resort,
  roadmapTitle,
}: TourIntroductionLineProps) => {
  const { details, strengths } = resort;
  const infos = [];

  if (details && details.length) {
    infos.push({
      title: roadmapTitle,
      items: details,
    });
  }

  if (strengths && strengths.length) {
    infos.push({
      title: highlightTitle,
      items: strengths,
    });
  }

  if (!infos.length) {
    return null;
  }

  return (
    <SiteContainer className="Line">
      <TourInformation infos={infos} />
    </SiteContainer>
  );
};
